<div class="audio-player-content" plyr plyrType="audio"
     [plyrPlaysInline]="true"
     [plyrSources]="audioSources"
     [plyrOptions]="audioOptions"
     (plyrInit)="assignPlayer($event)" (plyrEnded)="fileEnded($event)"  (plyrPlay)="played($event)"></div>
